(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apex-announcement-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('apex-marquee')) {
    class ApexMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.apex-marquee__track');
        this.group = this.querySelector('[data-group]');
        if (!this.track || !this.group) return;

        this.speed = Math.min(10, Math.max(1, parseInt(this.dataset.speed, 10) || 4));
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.lastWidth = 0;

        this.build();
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.build(true));

        this.observer = new ResizeObserver(() => {
          const w = this.getBoundingClientRect().width;
          if (Math.abs(w - this.lastWidth) < 2) return;
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.build());
        });
        this.observer.observe(this);

        this.onSelect = (e) => { if (this.inSection(e)) this.classList.add('is-paused'); };
        this.onDeselect = (e) => { if (this.inSection(e)) this.classList.remove('is-paused'); };
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        cancelAnimationFrame(this.raf);
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }

      inSection(e) {
        const section = this.closest('.shopify-section');
        return section && e.target && section.contains(e.target);
      }

      build(force) {
        const viewportWidth = this.getBoundingClientRect().width;
        if (!force && viewportWidth === this.lastWidth && this.classList.contains('is-ready')) return;
        this.lastWidth = viewportWidth;

        this.track.querySelectorAll('[data-clone]').forEach((node) => node.remove());
        if (this.reduced) return;

        const groupWidth = this.group.getBoundingClientRect().width;
        if (!groupWidth) return;

        const copies = Math.ceil(viewportWidth / groupWidth) + 1;
        for (let i = 0; i < copies; i++) {
          const clone = this.group.cloneNode(true);
          clone.removeAttribute('data-group');
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('*').forEach((el) => {
            [...el.attributes].forEach((attr) => {
              if (attr.name.startsWith('data-shopify')) el.removeAttribute(attr.name);
            });
          });
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          this.track.appendChild(clone);
        }

        // Speed 1 = 35px/s, speed 10 = 170px/s — same feel regardless of message count
        const pxPerSecond = 20 + this.speed * 15;
        this.style.setProperty('--apex-shift', groupWidth + 'px');
        this.style.setProperty('--apex-duration', (groupWidth / pxPerSecond).toFixed(2) + 's');
        this.classList.add('is-ready');
      }
    }
    customElements.define('apex-marquee', ApexMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-legal"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__apexLegal) return;
  window.__apexLegal = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function countUp(el) {
    var raw = el.getAttribute('data-ar-count') || '';
    var m = raw.match(/^(\D*)([\d,.]+)(.*)$/);
    if (!m) return;
    var target = parseFloat(m[2].replace(/,/g, ''));
    if (!isFinite(target)) return;
    var decimals = (m[2].split('.')[1] || '').length;
    var start = null, dur = 1500;
    function fmt(v) {
      var s = v.toFixed(decimals);
      if (m[2].indexOf(',') > -1) s = Number(s).toLocaleString('en-US', { minimumFractionDigits: decimals });
      return m[1] + s + m[3];
    }
    function step(t) {
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / dur);
      el.textContent = fmt(target * (1 - Math.pow(1 - p, 4)));
      if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
    }
    el.textContent = fmt(0);
    requestAnimationFrame(step);
  }

  function init(root) {
    if (!root || root.__arInit) return;
    root.__arInit = true;

    var hasIO = 'IntersectionObserver' in window;
    var motion = root.getAttribute('data-motion') === 'true' && !reduce.matches && hasIO;
    var counters = root.getAttribute('data-counters') === 'true' && !reduce.matches && hasIO;
    var reveals = root.querySelectorAll('[data-ar-reveal]');

    /* Reveal on scroll */
    if (motion) {
      root.classList.add('ar--anim');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* Count-up statistics */
    var nums = root.querySelectorAll('[data-ar-count]');
    if (counters && nums.length) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { countUp(en.target); cio.unobserve(en.target); }
        });
      }, { threshold: 0.6 });
      nums.forEach(function (n) { cio.observe(n); });
    }

    /* Contents list: active chapter + smooth jump */
    var links = root.querySelectorAll('[data-ar-toc-link]');
    var chapters = root.querySelectorAll('[data-ar-chapter]');
    if (links.length && hasIO) {
      var tio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var href = '#' + en.target.id;
          links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === href); });
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      chapters.forEach(function (c) { tio.observe(c); });
    }
    links.forEach(function (l) {
      l.addEventListener('click', function (e) {
        var target = document.getElementById(l.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', l.getAttribute('href'));
        var d = l.closest('details');
        if (d) d.open = false;
      });
    });

    /* Reading progress + watermark drift */
    var bar = root.querySelector('[data-ar-progress]');
    var wm = root.querySelector('[data-ar-wm]');
    var ticking = false;
    function update() {
      ticking = false;
      if (!root.isConnected) return;
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight;
      if (bar) {
        var total = r.height - vh;
        var p = total > 0 ? -r.top / total : (r.top < 0 ? 1 : 0);
        p = Math.max(0, Math.min(1, p));
        bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
        bar.parentNode.classList.toggle('is-on', r.top < vh * 0.4 && r.bottom > vh * 0.2);
      }
      if (wm && motion && r.top < vh && r.top > -vh) {
        wm.style.transform = 'translate3d(0,' + (-58 + r.top * -0.012).toFixed(2) + '%,0)';
      }
    }
    if (bar || (wm && motion)) {
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ar]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-ar]');
    if (!root) return;
    root.querySelectorAll('[data-ar-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    if (e.target.tagName === 'DETAILS') e.target.open = true;
  });
})();


  } catch(e) { console.error(e); }
})();
})();
